import React from 'react';
import autoBind from 'react-autobind';
import feathers from '../../../feathers';
import Avatar from 'material-ui/Avatar';
import Divider from 'material-ui/Divider';
import EditPermissionsToggles from '../../../components/PermissionsToggles/EditPermissions';
import EntityPermissionsToggles from '../../../components/PermissionsToggles/EntityPermissions';
import FacilityPermissionsToggles from '../../../components/PermissionsToggles/FacilityPermissions';
import { Panel } from '../../../components/Panel';
import noty from '../../../lib/noty';
import './style.scss';

// Split an array into two arrays with equal(ish) length
// TODO: this could be used to put the markerTypeCategories
// in alpha order down their columns...but it will be a PIA
// const splitArray = (array) => {
//   const middle = Math.ceil(array.length / 2)
//   return [
//     array.slice(0, middle),
//     array.slice(middle, array.length)
//   ]
// }

export default class User extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      touched: false,
      fetching: false,
      permission: this.props.user.getPermissions(),
      options: {
        facilities: [],
        buildings: [],
        markerTypeCategories: [],
        groups: []
      }
    };
    autoBind(this);
  }

  async componentDidMount() {
    // Ensure we have the latest user and permission from
    // the server.
    this.props.user.fetch();
    const permission = await this.state.permission.fetch();
    const options = await feathers.service('api/permissions-options').find();
    this.setState({ options, permission });
  }

  toggleAll({ name, value }) {
    const path = ['permissions', ...name.split('.')];
    if (value.toggle === true) {
      this.setState({
        touched: true,
        permission: this.state.permission.setIn(path, value.value)
      });
    } else {
      this.setState({
        touched: true,
        permission: this.state.permission.setIn(path, [])
      });
    }
  }

  handleArrayChange({ name, value }) {
    const path = ['permissions', ...name.split('.')];
    const { permission } = this.state;
    const array = permission.getIn(path);
    if (value.toggle === true) {
      this.setState({
        touched: true,
        permission: permission.setIn(path, [...array, value.value])
      });
    } else {
      this.setState({
        touched: true,
        permission: permission.setIn(
          path,
          array.filter(_id => _id !== value.value)
        )
      });
    }
  }

  handleFacility(facility, allChecked) {
    const path = ['permissions', 'resources', 'buildings'];
    const { permission } = this.state;
    const buildingIds = facility.buildings.map(building => building._id);
    const currentBuildings = permission.getIn(path);
    if (!allChecked) {
      // Use Set() to dedupe potential dupilicates
      const newBuildingIds = Array.from(
        new Set([...currentBuildings, ...buildingIds])
      );
      this.setState({
        touched: true,
        permission: permission.setIn(path, newBuildingIds)
      });
    } else {
      this.setState({
        touched: true,
        permission: permission.setIn(
          path,
          currentBuildings.filter(_id => !buildingIds.includes(_id))
        )
      });
    }
  }

  handleChange({ name, value }) {
    const path = ['permissions', ...name.split('.')];
    this.setState({
      touched: true,
      permission: this.state.permission.setIn(path, value)
    });
  }

  handleSubmit() {
    const { permission } = this.state;
    this.setState({ fetching: true, error: false });
    // Note we patch the permission here. Users cannot
    // Edit other user's info, just the permission
    permission
      .patch()
      .then(user => {
        this.setState({ fetching: false, touched: false });
        noty.success('User updated.');
      })
      .catch(err => {
        this.setState({ fetching: false });
        noty.errors(err);
      });
  }

  handleRemove() {
    noty.confirm(`Are you sure you want to delete this user?`, {
      onOk: () => {
        const { permission } = this.state;
        this.setState({ fetching: true });
        permission
          .remove()
          .then(user => {
            noty.success('User deleted.');
          })
          .catch(err => {
            this.setState({ fetching: false });
            noty.errors(err);
          });
      }
    });
  }

  // TODO: pull out the shared render logic across Account/User,
  // Account/Invitation, and Account/InvitationNew to beter componentize
  render() {
    const { user, currentUser } = this.props;
    const { permission, options, fetching, touched } = this.state;
    const { permissions } = permission;
    const { buildings, markerTypeCategories } = permissions.resources;
    const { groups } = permissions;
    return (
      <div id="User" className="margin-bottom-30">
        <Panel
          checkCanAdd="users"
          onSaveClick={this.handleSubmit}
          saveTitle="Save Permissions"
          onDeleteClick={
            user._id === currentUser._id ? null : this.handleRemove
          }
          fetching={fetching}
          touched={touched}
          touchedMessage="Are you sure that you want to leave? This user has unsaved changes."
        >
          <div style={{ padding: '0 16px' }}>
            <div className="row" style={{ margin: '16px 0' }}>
              <div className="col-xs-12">
                <Profile user={user} />
              </div>
            </div>
            <Divider />
            <EditPermissionsToggles
              permissions={permissions}
              onChange={this.handleChange}
              disabled={fetching}
            />
          </div>
          <div style={{ margin: '40px 0', padding: '0 16px' }}>
            <p>
              Choose which resources the user can view. This is different from
              the options above where you may limit whether the user has account
              and resource editing capabilities.
            </p>
          </div>
          <div className="row" style={{ padding: '0 16px' }}>
            <FacilityPermissionsToggles
              title="Facilities"
              className="col-md-5 col-sm-12 margin-bottom-30"
              entityArray={buildings}
              options={options}
              onChange={this.handleArrayChange}
              toggleAll={this.toggleAll}
              toggleFacility={this.handleFacility}
              disabled={fetching}
            />
            <EntityPermissionsToggles
              title="Marker Type Categories"
              className="col-md-7 col-sm-12 margin-bottom-30"
              entityArray={markerTypeCategories}
              entityName="resources.markerTypeCategories"
              options={options.markerTypeCategories}
              onChange={this.handleArrayChange}
              toggleAll={this.toggleAll}
              disabled={fetching}
            />
          </div>
          <div style={{ margin: '40px 0', padding: '0 16px' }}>
            <p>
              Assign optional groups to this user. Group can be used to search
              for users.
            </p>
          </div>
          <div className="row" style={{ padding: '0 16px' }}>
            <EntityPermissionsToggles
              title="User Groups"
              className="col-md-5 col-sm-12 margin-bottom-30"
              entityArray={groups}
              entityName="groups"
              options={options.groups}
              onChange={this.handleArrayChange}
              toggleAll={this.toggleAll}
              disabled={fetching}
            />
          </div>
        </Panel>
      </div>
    );
  }
}

const Profile = ({ user }) => (
  <div className="profile-container">
    <Avatar src={user.image.path} />
    <div className="profile-text">
      <p>{user.full_name}</p>
      <p>{user.email}</p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Account/User/index.jsx